PageApp.TokenUtils = function () {
  const tokenName = 'bidJSToken'

  return {
    getToken: function () {
      return window.localStorage.getItem(tokenName)
    }
  }
}
